// removed by extract-text-webpack-plugin
module.exports = {"IdeaListHead":"IdeaListHead__2nDNN","Title":"Title__2ye5D","Count":"Count__5HUNP","IdeaBtn":"IdeaBtn__2xnAs","Hidden":"Hidden__3KJeM","Show":"Show__1Jd7J","EmptyPage":"EmptyPage__3uVQL","TestIdeaBtn":"TestIdeaBtn__2H5We"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/IdeaList/index.css
// module id = 1531
// module chunks = 0